export const imageUrlToFile = async (url, filename, mimeType) => {
  const res = await fetch(url);
  const blob = await res.blob();
  return new File([blob], filename, { type: mimeType });
};

export const appendSizeToFilename = (file) => {
  const sizeInKB = Math.round(file.size / 1024);
  const [name, ...extParts] = file.name.split(".");
  const extension = extParts.pop();
  const baseName = [name, ...extParts].join(".");

  const newName = `${baseName}_${sizeInKB}KB.${extension}`;
  return new File([file], newName, { type: file.type });
};
